import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthleteAmaxSpeedWorkout = () => {
  const navigate = useNavigate();
  const { athlete } = useAthleteAuthContext();
  const location = useLocation();

  // Access phases data passed via location.state
  const phases = location.state?.phases;

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState("");
  const [themes, setTheme] = useState([]); // State for storing fetched phases

  const changeDate = (days) => {
    location.state = null; //clear state on date change as then it is new load
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const formatDateForAPI = (date) => {
    const utcDate = new Date(date); // Ensure UTC consistency
    utcDate.setUTCHours(0, 0, 0, 0); // Clear time component for accurate matching
    return utcDate.toISOString().split("T")[0];
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handleAmaxWarmupClick = () => {
    navigate("/athlete/warmup-routine/phase", {
      state: { phases, selectedDateState: selectedDate },
    });
  };

  const fetchThemes = async (date) => {
    setLoading(true);
    setError("");
    try {
      const formattedDate = formatDateForAPI(date); // Format date as YYYY-MM-DD
      const response = await fetch(
        `${API_URL.GET_ATHLETE_DYNAMIC_WORKOUT_THEMES_BY_DATE}${athlete.email}/${formatDateForAPI(formattedDate)}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (!response.ok) {
        setError(response?.error || "No themes found for the given date");
      }
      const data = await response.json();
      setTheme(data.themes);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // case of both themes and selecteddate found in state
    if (location.state?.themes && location.state?.selectedDate) {
      console.log("Using theme and date from location.state");
      console.log(location.state);
      setTheme(location.state.themes);
      setSelectedDate(location.state.selectedDate);
    }
    //case of only selecteddate found in state, other coukd be phases etc
    else if (location.state?.selectedDate) {
      console.log("Using only date from location.state");
      console.log(location.state);
      setSelectedDate(location.state.selectedDate);
      fetchThemes(location.state.selectedDate);
      console.log("Setting Date in state: " + selectedDate);
    } else {
      console.log("Fetching data for selected date");
      fetchThemes(selectedDate);
    }
  }, [location.state, athlete, selectedDate]);

  return (
    <AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">
          {formatDate(selectedDate)}
        </p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">
          <div className="flex justify-between gap-[68px] mb-4 px-5">
            <button
              onClick={handleAmaxWarmupClick}
              className="text-lightSmock text-base pb-2 font-normal"
            >
              Warmup
            </button>
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Workout
            </button>
          </div>

          {loading ? (
            <p className="text-white text-center">Loading themes...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">
              {error}
            </div>
          ) : (
            <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
              {themes &&
                themes.map((item) => (
                  <button
                    onClick={() =>
                      navigate(
                        "/athlete/amax-speed-workout/sprints/" + item._id,
                        { state: { phases, selectedDateState: selectedDate } },
                      )
                    }
                    key={item.phase_id}
                    className="w-full p-[14px] text-white font-normal border border-white/20 bg-transparent rounded-[15px] hover:bg-white/10 transition text-start"
                  >
                    {item.title} {/* Display label here */}
                  </button>
                ))}
            </div>
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowG = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowL = ({ onClick }) => (
  <svg
    onClick={onClick}
    className="hover:opacity-50 rotate-180 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ArrowD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
